import React from "react";
import { Navbar, Nav, Dropdown } from "react-bootstrap";
import { BsBell, BsPersonCircle } from "react-icons/bs";

const Topbar = () => {
  const username = localStorage.getItem("username") || "Admin";
  return (
    <Navbar expand="lg" className="px-3" style={{
      background: "#ffffff",
      borderBottom: "1px solid #e0f0ff",
      padding: "12px 24px",
    }}>
      <Navbar.Brand href="/dashboard" className="me-4" style={{ fontWeight: "700", color: "#0077cc" }}>
        Dashboard
      </Navbar.Brand>
      <Nav className="ms-auto d-flex align-items-center">
        <Dropdown align="end" className="me-3">
          <Dropdown.Toggle variant="transparent" id="dropdown-notifications" style={{ color: "#333", border: "none", boxShadow: "none" }}>
            <BsBell size={20} style={{ color: "#0077cc" }} />
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ minWidth: "250px" }}>
            <Dropdown.Header>Notifications</Dropdown.Header>
            <Dropdown.Item href="#">No new notifications</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown align="end">
          <Dropdown.Toggle variant="transparent" id="dropdown-profile" style={{ color: "#333", border: "none", boxShadow: "none" }} className="d-flex align-items-center">
            <BsPersonCircle size={22} className="me-2" style={{ color: "#0077cc" }} />
            <span style={{ fontWeight: "500" }}>{username}</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item href="#">Settings</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item href="#" onClick={() => { localStorage.clear(); window.location.href = '/auth/login'; }}>
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Nav>
    </Navbar>
  );
};

export default Topbar;
